import { IHttpService, IPromise, IQService } from 'angular';
import HttpService from '../http.service';
import { Agreement } from './agreement.model';

/* @ngInject */
export default class AgreementService {
  constructor(
    private $http: IHttpService,
    private httpService: HttpService,
    private $q: IQService
  ) {}

  public getDistantSalesAgreement(offerId: string): IPromise<Agreement> {
    if (typeof offerId !== 'string' || !offerId.trim()) {
      return this.$q.reject(new Error('Offer ID is required to load the distant sales agreement.'));
    }

    return this.httpService.extractResponseResult(
      this.$http.get('hafifmuzik/mobile/agreements/DISTANT_SALES', {
        params: { offerId }
      })
    ).then<Agreement>((agreement: Agreement) => {
      if (!agreement || typeof agreement.html !== 'string' || !agreement.html.trim()) {
        return this.$q.reject(new Error('Distant sales agreement HTML is missing.'));
      }

      return agreement;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/agreement/agreement.service.ts